import script from "./LayoutFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutFooter.vue?vue&type=script&setup=true&lang=js"

import "./LayoutFooter.vue?vue&type=style&index=0&id=2d31a298&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d31a298"]])

export default __exports__